import React from 'react';
import {ShadButton} from "../../shadCn/components/ui/ShadButton";

function ShadButtonBasic({className, variant, text, onClick}) {
    return (
        <ShadButton
            className={`text-[12px] bold ${className}`}
            variant={variant}
            onClick={onClick}
        >
            {text}
        </ShadButton>
    );
}

export default ShadButtonBasic;